import { GetServerSideProps } from 'next';
import PageLayout from '@/components/PageLayout';
import { useGlobal } from '@/utils/useGlobal';
import ReceiveCompoment from '@/components/Referral/Receive';
import { ReferralProvider } from '@/components/Referral/ReferralProvider';
import SEOlinksA from '@/components/SEOlinksA';
import CountDown from '@/components/Referral/Common/CountDown';

const ReferralRewards: React.FC<any> = ({ SEO }) => {
    const { useLang, useRouter } = useGlobal();
    const { locale } = useRouter();
    const { t } = useLang('referral');

    return (
        <>
            <SEO title={t('seo.title')} description={t('seo.desc')} />
            <SEOlinksA locale={locale} list={['eu', 'uk', 'it', 'es', 'fr', 'de', 'au', 'kr', 'ca', 'us', 'za', 'jp']} pathname={'referral-rewards'} />
            <PageLayout>
                <ReferralProvider>
                    {['us', 'ca'].includes(locale) && <CountDown />}
                    <ReceiveCompoment />
                </ReferralProvider>
            </PageLayout>
        </>
    );
};

export default ReferralRewards;

// 以下两个方法不可删除，否则会重复触发 _app.js 中 getInitialProps 中的请求
export const getServerSideProps: GetServerSideProps = async ({ locale, req }) => {
    const whiteLocaleList = ['us', 'ca'];
    if (!whiteLocaleList.includes(locale as string)) {
        return { notFound: true };
    }
    // 获取登陆信息
    const userInfoJson = req.cookies?.userInfo || '';
    let isLogin = false;
    try {
        const userInfo = JSON.parse(userInfoJson);
        isLogin = !!userInfo.token;
    } catch {}

    return {
        props: {
            isLogin,
        },
    };
};
